import { gql } from '@apollo/client'

export const GET_ITEM_GROUPS = gql`
  query GetItemGroups {
    itemGroups {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on ItemGroupsSuccess {
        itemGroups {
          id
          name
        }
      }
    }
  }
`

export const GET_ALL_ITEMS = gql`
  query GetItems {
    items(searchString: "") {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ItemsSuccess {
        items {
          id
          name
          unitPrice
          vat
          vatCategory
          unit
          limitedUsage
          isInventoryTracked
          groups
        }
      }
    }
  }
`

export const GET_SETTINGS = gql`
  query GetSettings {
    settings {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on GetSettingsSuccess {
        settings {
          operators {
            id
            name
            defaultStation
          }
          stations {
            id
            name
            shortName
            type
            address
            zipcode
            city
            coords {
              lat
              long
            }
          }
          towingReasons
          labels
          agreements {
            id
            text
            type
          }
          modules {
            sos
            autoliitto
            shifts
            useExtendedRoutes
          }
          notifications {
            enabled
            method
          }
          sms {
            enabled
            greeting
            footer
          }
          subcontracts {
            contractorId
            contractorName
            allowWeb
            allowApp
          }
          shiftGroup {
            id
            groupName
            currentStart
            currentEnd
            enableWait
            enableStandby
            enableOvertime
            enableNight
            enableEvening
            periodLength
            jobType
          }
          paymentTerminalsEnabled
          companyData {
            companyName
            address
            zipcode
            city
            email
            phone
            paymentLinkEnabled
          }
          companies {
            id
            name
          }
          AlDelayedTowingReasons {
            value
            delayedTowing
            label
          }
          defaultItemsIncludeVat
        }
      }
    }
  }
`

export const GET_AL_ARC_CODES = gql`
  query GetAlArcCodes {
    alArcCodes {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on GetArcCodesAlDataSuccess {
        AlArcCodes {
          components {
            type
            code
            fault_codes
          }
          towing_components {
            type
            code
            fault_codes
          }
          road_service_components {
            type
            code
            fault_codes
          }
          descriptions {
            type
            code
          }
          completions {
            type
            code
          }
        }
      }
    }
  }
`
export const GET_AL_REPAIR_SHOPS= gql`
  query GetAlRepairShops {
    alRepairShops {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on GetRepairShopsAlDataSuccess {
        AlRepairShops {
          id
          name
          location {
            address
            postcode
            coordinates {
              lat
              lon
            }
            city
          }
          serviceChannels {
            id
            type
          }
        }
      }
    }
  }
`

export const GET_PREFERENCES = gql`
  query GetPreferences {
    preferences {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on GetPreferencesSuccess {
        preferences {
          id
          filters
        }
      }
    }
  }
`

export const GET_NOTIFICATIONS = gql`
  query GetNotifications {
    notifications {
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on GetNotificationsSuccess {
        notifications {
          title
          message
          type
          actions {
            label
            url
            type
          }
        }
      }
    }
  }
`
